module.exports = __webpack_public_path__ + "img/lesson3.c2582a42.png";